/**
 * Layout component that queries for data
 * with Gatsby's StaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/static-query/
 */

import React, { useEffect } from 'react';
import Helmet from 'react-helmet';
import { graphql, useStaticQuery } from 'gatsby';
import firebase from 'gatsby-plugin-firebase';
import { WOW } from 'wowjs/dist/wow';
import Footer from './footer';

import '../scss/main.scss';

const Layout = (props) => {

  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
        }
      }
      allContentfulContacts {
        edges {
          node {
            id
            type
            value
          }
        }
      }
    }
  `);

  useEffect(() => {
    new WOW({
      mobile: false,
    }).init();
  });

  useEffect(() => {
    firebase.analytics();
  });

  const contacts = {};
  // eslint-disable-next-line no-return-assign
  data.allContentfulContacts.edges.forEach(({ node: { type, value } }) => (contacts[type] = value));

  return (
    <div className="pagecontainer">
      <Helmet bodyAttributes={{ class: 'body' }} />
      {props.children}
      <Footer items={contacts} />
    </div>
  )
}

export default Layout;
